
import Template from '@/shared/app/model/templating/Template';
import DishGroup from '@/shared/dish/ui/DishGroup.vue';
import _ from 'lodash';
import Component from 'vue-class-component';

@Component
export default class DishLayout extends DishGroup {
  mounted() {
    //
  }

  get nCols() {
    return this.config.cols ? Number(this.config.cols) : 1;
  }

  get rows() {
    return _.chunk(this.activeDishesIndexes, this.nCols);
  }

  get style() {
    return {
      padding: this.config.padding?.toString() || '1rem',
      'background-color':
        this.config.backgroundColor?.toString() || 'transparent',
    };
  }

  get dishSeparatorStyle() {
    return {
      margin: `0 ${this.spaceBetween}`,
      'border-style': this.config.borderStyle?.toString() || 'solid',
      'border-color': this.config.borderColor?.toString() || 'black',
      'border-width': `0 ${this.config.borderWidth?.toString() || '1px'} 0 0`,
    };
  }

  get rowSeparatorStyle() {
    return {
      margin: `${this.spaceBetween} 0`,
      ...(this.config.border === true
        ? {
          'border-style': this.config.borderStyle?.toString() || 'solid',
          'border-color': this.config.borderColor?.toString() || 'black',
          'border-width': `${this.config.borderWidth?.toString() || '1px'
            } 0 0 0`,
        }
        : { border: 'none' }),
    };
  }

  get spaceBetween() {
    return this.config.spaceBetween?.toString() || '0.5rem';
  }

  get dishesSizeFactor() {
    return (
      this.maxSizeFactor -
      (this.activeDishesIndexes.length - 1) *
      ((this.maxSizeFactor - this.minSizeFactor) / this.maxDishes)
    );
  }

  get maxDishes() {
    return Number(this.config.maxDishes) || 4;
  }

  get minSizeFactor() {
    return Number(this.config.minSizeFactor) || 2;
  }

  get maxSizeFactor() {
    return Number(this.config.maxSizeFactor) || 2;
  }

  dishConfig(index: string): Template {
    return {
      config: {
        index,
        ...this.dataset('dishConfig'),
        sizeFactor: this.dishesSizeFactor.toString(),
      },
      datasets: {
        dishes: this.dishes,
      },
    };
  }
}
